export default __webpack_public_path__ + "static/media/register_bg_2.4f2cb0ac.png";